module.exports = __webpack_public_path__ + "img/erp-feature5.d5d7bea1.png";